// The reserve modal's model picker — the same supported models shown on
// /models and the home-page grid, multi-select. Unlike the home-page grid
// (LLMs only — see data/modelGrid.js), this list stays flat across every
// modality: a workload can legitimately want reserved capacity for an image
// or voice model too, so restricting the picker to text models would be a
// real functional gap, not just a copy mismatch. Ordered LLMs first
// (matching data/arenaModels.js's CURATED_LLMS), then image/vision/voice.
// `maker` matches the keys in components/models/ModelLogo.jsx's
// LOGO_BY_MAKER map (same convention as data/modelGrid.js) so logos resolve
// correctly. `comingSoon` marks a model as not yet live — still selectable,
// just badged.
export const TOP_MODEL_OPTIONS = [
  { name: 'Kimi 3', maker: 'Moonshot' },
  { name: 'GLM 5.2 Max', maker: 'Z.ai' },
  { name: 'MiniMax M3', maker: 'MiniMax' },
  { name: 'DeepSeek V4 Pro', maker: 'DeepSeek' },
  { name: 'DeepSeek V4 Flash', maker: 'DeepSeek' },
  { name: 'Qwen 3.6 27B', maker: 'Alibaba' },
  { name: 'Muse Glimmer', maker: 'Meta' },
  { name: 'Gemma 4 31B', maker: 'Google' },
  { name: 'Qwen 3.8 Max', maker: 'Alibaba', comingSoon: true },
  { name: 'HunyuanImage 3.0', maker: 'Tencent' },
  { name: 'Qwen2.5-VL 72B', maker: 'Alibaba' },
  { name: 'Kimi-Audio 7B', maker: 'Moonshot' },
]

export const DEFAULT_MODEL = 'Qwen 3.8 Max'
// No figure here on purpose: this string is shown to the visitor in the reserve
// modal and is relayed into the Slack/DB payload as "Plan". Any amount put here
// is a public price quote.
export const DEFAULT_RATE = 'One fixed monthly bill'
export const DEFAULT_BILLING = 'Flat rate'
export const CAL_LINK = 'nexlayer/liquidbrain-ai-inference-engine'
export const CAL_NS = 'liquidbrain-ai-inference-engine'
